import React, { useEffect, useState } from "react";
import { CircularProgress } from "@mui/material";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mhome/ui";

const DeleteCardDialog = ({ open, card, onClose, onDelete }) => {
  const [cardId, setCardId] = useState("");
  const [isRunning, setIsRunning] = useState(false);

  useEffect(() => {
    if (card) {
      setCardId(card.id);
    }
  }, [card]);

  const handleDelete = async () => {
    setIsRunning(true);
    try {
      await onDelete(cardId);
    } finally {
      setIsRunning(false);
      onClose();
    }
  };

  const isAutomationCard = card?.widgets?.some(
    (widget) => widget.source === "automation"
  );

  return (
    <Dialog open={open} onClose={onClose} variant="pops">
      <DialogTitle>Confirm Delete</DialogTitle>
      <DialogContent>
        <Typography variant="body1">Do you want to delete the card?</Typography>
        {isAutomationCard && (
          <Typography
            variant="body2"
            className="mt-2"
            style={{
              color: "hsl(var(--muted-foreground))",
            }}
          >
            This won&apos;t delete the related automation.
          </Typography>
        )}
      </DialogContent>
      <DialogActions className="justify-between px-4 pb-4">
        <Button
          onClick={onClose}
          disabled={isRunning}
          variant="outlined"
          className="normal-case"
          style={{ boxShadow: "none" }}
          onMouseEnter={(e) => {
            e.currentTarget.style.boxShadow = "none";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.boxShadow = "none";
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={handleDelete}
          disabled={isRunning}
          color="error"
          variant="contained"
          className="normal-case"
          style={{ boxShadow: "none" }}
          onMouseEnter={(e) => {
            e.currentTarget.style.boxShadow = "none";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.boxShadow = "none";
          }}
        >
          Delete
          {isRunning && <CircularProgress size={16} className="ml-2" />}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export const BatchDeleteDialog = ({ open, count, onClose, onDelete }) => {
  const [isRunning, setIsRunning] = useState(false);

  const handleDelete = async () => {
    setIsRunning(true);
    try {
      await onDelete();
    } finally {
      setIsRunning(false);
      onClose();
    }
  };

  return (
    <Dialog open={open} onClose={onClose} variant="pops">
      <DialogTitle>Confirm Delete</DialogTitle>
      <DialogContent>
        <Typography variant="body1">
          Are you sure you want to delete {count} selected card
          {count !== 1 ? "s" : ""}?
        </Typography>
      </DialogContent>
      <DialogActions className="justify-between px-4 pb-4">
        <Button
          onClick={onClose}
          disabled={isRunning}
          variant="outlined"
          className="normal-case"
          style={{ boxShadow: "none" }}
          onMouseEnter={(e) => {
            e.currentTarget.style.boxShadow = "none";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.boxShadow = "none";
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={handleDelete}
          disabled={isRunning}
          color="error"
          variant="contained"
          className="normal-case"
          style={{ boxShadow: "none" }}
          onMouseEnter={(e) => {
            e.currentTarget.style.boxShadow = "none";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.boxShadow = "none";
          }}
        >
          Delete
          {isRunning && <CircularProgress size={16} className="ml-2" />}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteCardDialog;
